import React, { useState } from "react";
import styles from "./LearningPlayer.module.css";

const KEY_LETTERS = ["A", "B", "C", "D", "E", "F"];

export default function InlineQuizStep({ step, heading, fontSize }) {
  const [selected, setSelected] = useState(null);
  const options = Array.isArray(step?.quizOptions) ? step.quizOptions : [];

  return (
    <>
      <h1 className={styles.heading}>{heading}</h1>
      {options.length === 0 ? (
        <div className={styles.fallbackCard}>
          No answers defined for this quiz step.
        </div>
      ) : (
        <div className={styles.quizAnswers}>
          {options.map((opt, i) => {
            const isSelected = selected === i;
            return (
              <button
                key={i}
                type="button"
                onClick={() => setSelected(i)}
                className={`${styles.quizAnswer} ${
                  isSelected ? styles.quizAnswerSelected : ""
                }`}
                style={{ fontSize }}
                aria-pressed={isSelected}
              >
                <span className={styles.quizAnswerKey}>
                  {KEY_LETTERS[i] || String(i + 1)}
                </span>
                <span style={{ flex: 1 }}>{opt.text}</span>
              </button>
            );
          })}
        </div>
      )}
    </>
  );
}
